import { useEffect, useMemo } from 'react';
import { useEpicsStoreIsInitialised } from '@atlassian/jira-backlog-epics-store/src/selectors/index.tsx';
import { useEpicQueryLite } from '../../../services/queries/epics-lite';
import { useBacklogSelector } from '../../../state';
import { getFirstLevelHierarchyName } from '../../../state/selectors/issue-hierarchy';
import { useIsCMPBacklog } from '../../../state/state-hooks/capabilities';
import { transformLiteQueryData } from './utils';

export const useInitEpicData = (boardId: number) => {
	const isCompanyManaged = useIsCMPBacklog();
	const firstLevelHierarchyName = useBacklogSelector(getFirstLevelHierarchyName);

	const [isInitialised, { initState, resetState, updateQueryState, updateEpicsAttributes }] =
		useEpicsStoreIsInitialised();

	const { data, loading, error } = useEpicQueryLite(boardId, isCompanyManaged);

	const initData = useMemo(
		() => transformLiteQueryData(data, isCompanyManaged, firstLevelHierarchyName),
		[data, firstLevelHierarchyName, isCompanyManaged],
	);

	useEffect(() => {
		if (error) {
			updateEpicsAttributes({ isLoading: false, hasError: true });
		}
		updateQueryState({ loading, error });
	}, [loading, error, updateQueryState, updateEpicsAttributes]);

	useEffect(() => {
		if (data && !loading && !isInitialised) {
			initState({
				...initData,
			});
		}
	}, [boardId, data, initData, initState, isCompanyManaged, isInitialised, loading]);

	useEffect(
		() => () => {
			resetState();
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[],
	);
};
